<template>
  <V1 v-if="topoVersion == 1" />
  <div class="topo-box">
    <V2 v-if="topoVersion == 2" :topology-data="topologyData" />
  </div>

</template>

<script setup lang="ts">
import { ref, reactive, computed, onMounted, onUnmounted, watch } from 'vue'
// import { Topology } from '@/topo/core/topology'
// import '@/topo/core/style.css'
import { useStationContext } from '@/views/station-monitor/detail/composables/useStationContext'
import { getTopology } from "@/api/device/topo"
// import DragZoomContainer from '@/components/DragZoomContainer.vue'

import V1 from './v1/index.vue'
import V2 from './v2/index.vue'

const { stationId, stationName, stationBaseData } = useStationContext()


const topoVersion = ref(1)
const topologyData = ref(null)

async function getTopologyJSON() {
  const r = await getTopology(stationId.value) 
  const d = JSON.parse(r?.data?.stationTopology || '{}')
  // 使用新拓扑图
  if (d.version === 2) {
    topoVersion.value = 2
  } else {
    topoVersion.value = 1
  }

  topologyData.value = d
}


getTopologyJSON()


watch(stationId, () => {
  getTopologyJSON()
})




</script>


<style scoped>

.topo-box {
  height: calc(100vh - 210px);
  /* border: 1px solid red; */
}
</style>
